import {Component, OnInit} from '@angular/core';
import {DisputeDetailsAction} from './dispute-details.action';
import {DataManagerService} from '../../../data/services/DataManager/data-manager.service';
import {CasesModel, DisputeContainerModel, FileModel} from '../../../data/model/DisputeModel/dispute.model';
import {AppConstants} from '../../../shared/constants/app-constants';
import {ActivatedRoute} from '@angular/router';
import {PermissionConstants} from '../../../shared/constants/permission-constants';
import {ApiResponseModel} from '../../../data/model/ApiResponseModel/api-response.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {UploadModal} from '../../../data/model/UploadModel/upload.modal';
import {AlertMessageDialogComponent} from '../../../dialogs/alert-message-dialog/alert-message-dialog.component';


@Component({
    selector: 'app-dispute-details',
    templateUrl: './dispute-details.component.html',
    styleUrls: ['./dispute-details.component.css'],
    standalone: false
})
export class DisputeDetailsComponent extends DisputeDetailsAction
  implements OnInit {

  fileList: File[];
  dispute: DisputeContainerModel;
  can_download: boolean;
  step = 0;
  primaryCaseId: any;
  multipartRequest: FormData;
  response: string;
  uploadModel: UploadModal;
  fileURL: string;
  topErrorMessage: string;
  keys: string[];
  keys1: string[];
  // PDT-35660: set when an evidence upload of the current submit is rejected. The case is
  // then not submitted, because /submit faxes the case packet to the bank.
  private evidenceUploadFailed = false;
  // True from the click until the upload and submit round trip has finished. Overlapping
  // clicks are ignored, so one attempt can neither reset another attempt's failure nor
  // upload the same files twice.
  isSubmitting = false;
  // The files and comment as they were at click time. The upload chain reads these, so editing
  // the rows while an upload is pending cannot skip a file or change what is submitted.
  private uploadQueue: File[] = [];
  private uploadComment = '';
  // Names of the files rejected in the current attempt, for the message shown to the merchant.
  private failedUploads: string[] = [];
  casesDataList: ApiResponseModel<CasesModel>;
  casesService = AppConstants.SERVICE_NAME_CASES;
  evidencesService = AppConstants.SERVICE_NAME_EVIDENCES;
  card_img_obj = {
    'D': '../../../../assets/images/disc.png', 'V': '../../../../assets/images/visa.png',
    'A': '../../../../assets/images/amex.png', 'M': '../../../../assets/images/master.png',
    'J': '../../../../assets/images/jcb.png'
  };

  constructor(dataManager: DataManagerService, route: ActivatedRoute, snackBar: MatSnackBar, private dialog: MatDialog) {
    super();
    this.dataManager = dataManager;
    this.errorMsg = null;
    this.snackBar = snackBar;
    this.fileList = [];
    this.uploadModel = new UploadModal();
    this.casesDataList = new ApiResponseModel();
    this.route = route;
    this.route.queryParams.subscribe(params => {
      const masterMerchant = params['scope'] === 'master-merchant';
      this.casesService = masterMerchant ? AppConstants.SERVICE_NAME_MASTER_MERCHANT_CASES : AppConstants.SERVICE_NAME_CASES;
      this.evidencesService = masterMerchant ? AppConstants.SERVICE_NAME_MASTER_MERCHANT_EVIDENCES : AppConstants.SERVICE_NAME_EVIDENCES;
    });
    this.can_download = this.permissionCheck(
      PermissionConstants.PERMISSION_DOWNLOAD_DISPUTE
    );
    if (this.fetchIdFromRouteQueryParams()) {
      this._getDisputeDetailsUrl =
        AppConstants.BASE_URL +
        this.casesService +
        '/' +
        this.id +
        '?include=evidences,dispute_subbmissions';
    }

    this.dispute = new DisputeContainerModel();
    this.getDisputeDetails();
  }

  ngOnInit() {
    this.addfilePicker();
  }

  addfilePicker() {
    if (this.fileList.length < 3) {
      if (!this.isNullOrUndefined(this.fileList[this.fileList.length - 1]) || this.fileList.length < 1) {
        let file: File;
        this.fileList.push(file);
      } else {
        this.showSnackBar('Select a file first!', 'Ok', 3000);
      }

    }
  }

  removeFiles(index) {
    console.log(this.fileList);
    if (this.fileList.length > 1) {
      this.fileList.splice(index, 1);
    }

    console.log(this.fileList);
  }

  openFilePicker(i) {
    document.getElementById(i.toString()).click();
  }

  addFile(file: FileList, index) {
    this.fileList[index] = file[0];
  }

  protected passDisputeResponse(res) {
    this.dispute = res;
    const primaryData = this.dispute.primary_case.data;
    const relatedCases = this.dispute.related_cases?.data ?? [];
    const primaryCase = primaryData.is_primary_case
      ? primaryData
      : relatedCases.find(x => x.is_primary_case);
    this.primaryCaseId = primaryCase ? primaryCase.id : undefined;
    this.response = 'Case number#: ' + primaryData.case_number;
  }

  protected passDisputeError(err) {
    console.log(err);
  }

  download(data) {
    window.open(data);
  }


  /**
   * PayPal disputes are mirrored into the shared cases table by the PayPal webhook
   * handler, which flags them with tsys_fiserv_indicator 'P' ('T' is TSYS, 'F' is
   * Fiserv) and keys them on the PayPal dispute id. Those cases carry no chargeback
   * document to download - the dispute lives in PayPal's resolution centre instead.
   */
  isPaypalCase(cases: CasesModel): boolean {
    if (!cases) {
      return false;
    }

    return cases.tsys_fiserv_indicator === 'P' ||
      (!!cases.case_number && cases.case_number.indexOf('PP-') === 0);
  }

  paypalCaseUrl(cases: CasesModel): string {
    return AppConstants.PAYPAL_RESOLUTION_CENTER_URL + cases.case_number;
  }

  statusVariant(status: string): 'good' | 'info' | 'warn' | 'bad' | 'neutral' {
    switch (status) {
      case 'Currently resolved in Merchant\'s favor':
        return 'good';
      case 'Currently resolved in Bank\'s favor':
        return 'bad';
      case 'Pending':
        return 'warn';
      default:
        return 'neutral';
    }
  }

  relatedCaseStatusVariant(status: string): 'good' | 'info' | 'warn' | 'bad' | 'neutral' {
    switch (status) {
      case 'Won':
        return 'good';
      case 'Lost':
        return 'bad';
      case 'Pending':
        return 'warn';
      default:
        return 'neutral';
    }
  }

  viewFile(file) {

    console.log('viewFile', file);
    this._getChargeBackPdf = AppConstants.BASE_URL + this.casesService + '/' + this.id + AppConstants.SERVICE_NAME_FILE + '/' + file.id;
    this.getDisputeChargeBackPdf();
    this.showSnackBar('File is loading.', 'Ok', 3000);

  }

  viewEvidence(file) {

    console.log('viewFile', file);
    this._getChargeBackPdf = AppConstants.BASE_URL + this.evidencesService + '/' + file.id + AppConstants.SERVICE_NAME_DOWNLOAD;
    this.getDisputeChargeBackPdf(file);
    this.showSnackBar('File is loading.', 'Ok', 3000);

  }


  protected passChargeBackPdfResponse(res: any) {
    console.log(res);
    this.openFileInBrowser(res);
  }

  protected passChargeBackPdfError(err: any) {
    console.log(err);
  }

  protected passChargeBackPdfComplete() {
   // window.open(this.fileURL, '_blank');
    const a = document.createElement('a');
    a.href = this.fileURL;
    a.setAttribute('target', '_blank');
    a.click();
  }

  openFileInBrowser(res) {
    console.log(res);
    const pdfFile = res;
    this.fileURL = URL.createObjectURL(pdfFile);
  }

  switchCases(obj) {
    if (this.isSubmitting) {
      return;
    }
    console.log(obj, 'switchCases');
    this.dispute.related_cases.data = [this.dispute.primary_case.data, ...this.dispute.related_cases.data.filter(cases => cases.id !== obj.id)];
    this.dispute.primary_case.data = obj;
    this.response = 'Case Number#: ' + obj.case_number;
  }

  protected postEvidenceResponse(res: any, i) {

    this.dispute.primary_case.data.evidence.data.push(res.data);
    this.uploadFiles(i + 1);
  }

  protected postEvidenceError(error: any, i) {
    this.evidenceUploadFailed = true;
    this.failedUploads.push(this.uploadQueue[i]?.name ?? 'A file');
    this.topErrorMessage = error?.errors;
    this.keys = Object.keys(this.topErrorMessage || {});
    this.keys1 = Object.values(this.topErrorMessage || {});
    this.uploadFiles(i + 1 );
  }

  onSubmit() {
    if (this.isSubmitting) {
      return;
    }
    if ((this.fileList[0] == null || this.fileList[0] == undefined)) {
      this.showSnackBar('Please select a file first!', 'Ok', 3000);
    } else {
      this._postEvidenceUrl = AppConstants.BASE_URL + this.casesService + '/' + this.dispute.primary_case.data.id + AppConstants.SERVICE_NAME_EVIDENCE;
      this._postWrittenResUrl = AppConstants.BASE_URL + this.casesService + '/' + this.dispute.primary_case.data.id + AppConstants.SERVICE_NAME_SUBMIT;
      this.evidenceUploadFailed = false;
      this.failedUploads = [];
      this.topErrorMessage = '';
      this.keys = [];
      this.keys1 = [];
      this.isSubmitting = true;
      this.uploadQueue = [...this.fileList];
      this.uploadComment = typeof this.uploadModel.text === 'undefined' ? '' : this.uploadModel.text;
      this.uploadFiles(0);
    }

  }

  uploadFiles(i) {
    if ((this.uploadQueue[i]) && i < this.uploadQueue.length) {
      this.multipartRequest = new FormData();
      this.multipartRequest.append('file', this.uploadQueue[i], this.uploadQueue[i].name);
      this.multipartRequest.append('text', this.uploadComment);
      this.postEvidence(this.multipartRequest, i);
    } else {
      this.fileList = [];
      this.addfilePicker();
      if (this.evidenceUploadFailed) {
        this.showSnackBar(this.failedUploads.join(', ') + ' could not be uploaded, so nothing was sent to the bank. ' +
          'Fix the problem and submit again.', 'Ok', 8000);
        this.isSubmitting = false;
      } else if (this.response) {
        this.uploadWrittenResponse();
      } else {
        this.isSubmitting = false;
      }
    }

  }
  showComment(text, cnt) {
    const data = {
      head : 'Comment to Document ' + (cnt + 1),
      message: text,
      disableClose: true
    };
    const dialog = this.dialog.open(AlertMessageDialogComponent, {data});
  }
  uploadWrittenResponse() {
      const postBody = {};
      postBody['message'] = this.response;
      this.postWrittenRes(postBody);
  }

  protected postWrittenResError(err) {
    this.isSubmitting = false;
    console.log(err);
  }

  protected postWrittenResResponse(res) {
    this.isSubmitting = false;
    console.log(res);
  }

  }
